// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".system_button-module__iconLeft--1qt_e{color:inherit;opacity:0.8;cursor:pointer;padding:0 4px 0 0}.system_button-module__iconRight--MZ-2l{color:inherit;opacity:0.8;cursor:pointer;padding:0 0 0 4px}\n", ""]);
// Exports
exports.locals = {
	"iconLeft": "system_button-module__iconLeft--1qt_e",
	"iconRight": "system_button-module__iconRight--MZ-2l"
};
module.exports = exports;
